import {
    Component, Mixins, Watch,
} from 'vue-property-decorator';
import isEqual from 'lodash.isequal';
import { digits, separated } from '@nodes/helpers/number';
import { date } from '@nodes/helpers/date';
import { YPanel, YTable, YEmpty } from '@components/index';
import CoreMixin from '@nodes/mixins/Core';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import Props from './props';

@Component({
    components: {
        YPanel,
        YTable,
        YEmpty,
    },
})

/**
 * @name ProfileTransactions
 */
export default class ProfileTransactions extends Mixins(CoreMixin, HybridMixin, Props) {
    digits = digits;
    separated = separated;
    date = date;

    selectedFilter: string = 'all';
    transactions = null;
    tableHeader = [
        {
            id   : 'tracking_number',
            title: this.$t('dashboard.transactions.table.tracking_number'),
        },
        {
            id   : 'date',
            title: this.$t('dashboard.transactions.table.date'),
        },
        {
            id   : 'price',
            title: this.$t('dashboard.transactions.table.price'),
        },
        {
            id   : 'status',
            title: this.$t('dashboard.transactions.table.status'),
        },
    ];

    /**
     * Fetch Gates if wallets exist
     *
     * @param {object} val
     * @param {object} oldVal
     */
    @Watch('userMetadata', { immediate: true, deep: true })
    onWalletChanged(val: object, oldVal: object) {
        this.$wait.start('fetch-transactions');
        if (val && !isEqual(val, oldVal)) {
            this.fetchTransactions();
        }
    }

    /**
     * Return the filtered transactions
     * 
     * @returns {Array}
     */
    get filteredTransactions(): Array<{[k: string]: any}> {
        let list = null;

        if (this.selectedFilter === 'all') {
            list = this.transactions;
        } else if (this.selectedFilter === 'received') {
            // TODO: Update this after resource added
            // list = this.transactions.filter((i) => i.is_closed === false);
            list = this.transactions;
        } else if (this.selectedFilter === 'paid') {
            // TODO: Update this after resource added
            list = this.transactions;
        }
        return list;
    }

    /**
     * Fetch Transactions
     * 
     * @returns {*}
     */
    fetchTransactions(): any {
        this.$wait.start('fetch-transactions');
        const params = {
            id: this.userMetadata.authenticated_user,
        };
        return this.$services[this.fetchTransactionsService.name][this.fetchTransactionsService.api](params).then((response) => {
            this.transactions = response.data.results;
        }).catch((error: object) => {
            this.handleError(error);
        }).finally(() => {
            this.$wait.end('fetch-transactions');
        });
    }

    /**
     * Set selected filters
     *
     * @param {string} filter
     */
    filterItems(filter: string) {
        this.selectedFilter = filter;
    }
}
